import { getQBankStructureLevelLabelByCategory } from '@exam-management/common/utils';
import {
  findPreviousEnabledLevel,
  type QBankStructureLevel,
  type QBankStructureLevelCategory,
} from '@exam-management/qbs-provider';
import { z } from 'zod';

import type { LocationFormValues } from '../containers';

export function getLocationSchema(
  key: QBankStructureLevelCategory,
  qbsLevels: QBankStructureLevel[],
) {
  return z
    .object({
      value: z.string(),
      label: z.string(),
    })
    .nullish() // NOTE: use for bypass a required state of zod and custom handling at refine instead
    .refine(
      (value) => {
        const currentLevel = qbsLevels.find((level) => level.category === key);
        if (currentLevel?.enabled) {
          if (!value) {
            return false;
          }
        }

        return true;
      },
      {
        message: `กรุณาเลือก${getQBankStructureLevelLabelByCategory(key)}`,
      },
    );
}

export function getLocationDefaultValue(qbsLevels: QBankStructureLevel[]) {
  return qbsLevels.reduce((acc, qBankStructureLevel) => {
    const aboveEnabledLevel = findPreviousEnabledLevel(qbsLevels, qBankStructureLevel.id);
    if (aboveEnabledLevel === null && qBankStructureLevel.enabled) {
      acc[qBankStructureLevel.category] = null;
    } else {
      acc[qBankStructureLevel.category] = undefined;
    }
    return acc;
  }, {} as LocationFormValues);
}

interface ItemSetLocationSectionType {
  location: LocationFormValues;
}

interface ItemSetQuestionDetails {
  details: {
    name: string;
    paragraph: string;
  };
}

export type ItemSetCreationFormInput = ItemSetQuestionDetails & ItemSetLocationSectionType;
